<div
  class="selected-availability-dialog"
  data-cy="selected-availability-dialog">
  <div class="dialog-header">
    <h1
      mat-dialog-title
      *ngIf="department">
      {{ organisation?.name + " - " + department?.name }}
    </h1>
    <h1
      mat-dialog-title
      *ngIf="!department">
      {{ ("createEmployment" | i18n) || "Einsatz erstellen" }}
    </h1>
  </div>
  <div
    mat-dialog-content
    (keydown.enter)="close()">
    <div
      class="job-info"
      data-cy="selected-availability-dialog-job-info"
      *ngIf="data.startDate && data.endDate">
      {{ data.startDate | date: "dd.MM.yyyy" }} -
      {{ data.endDate | date: "dd.MM.yyyy" }}
    </div>
    <div
      class="user-info"
      *ngIf="certificates && certificates.length > 0">
      <mat-icon
        class="user-info-icon"
        svgIcon="school"></mat-icon>
      <div>
        <div
          *ngFor="let certificate of certificates"
          [attr.data-cy]="
            'selected-availability-certificate-' + certificate._id
          ">
          {{ certificate.name }}
        </div>
      </div>
    </div>
  </div>
  <div
    mat-dialog-actions
    class="availability-dialog-actions">
    <ng-container *ngIf="customer">
      <button
        mat-button
        class="bordered-button"
        type="button"
        (click)="close()"
        data-cy="selected-availability-dialog-close-button">
        {{ ("close" | i18n) || "Schliessen" }}
      </button>
      <div class="flex-spacer"></div>

      <button
        class="bordered-button"
        type="button"
        mat-button
        (click)="continue()"
        data-cy="selected-availability-dialog-invite-button">
        {{ ("create" | i18n) || "Erstellen" }}
      </button>
    </ng-container>
  </div>
</div>
